import * as yup from 'yup'

export const reportFinalizeValidation = yup.object().shape({
    companyId: yup.string().required('Harus diisi'),
    periodId: yup.string().required('Harus diisi'),
    documents: yup.array().min(1, "Minimal 1 file")
                .test("fileType", "File harus pdf", (files) =>
                    files?.every((file) => ["application/pdf"].includes(file.type))
                )
                .test("fileSize", "File maksimal 3mb", (files) =>
                        files?.every((file) => file.size <= 3 * 1024 * 1024)
                ),
}).required()

export const reportPreviewValidation = yup.object().shape({
    companyId: yup.string().required('Harus diisi'),
    periodId: yup.string().required('Harus diisi'),
}).required()